import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


export type frequencyData = 'daily' | 'weekly' | 'annual' | 'monthly' | 'quarterly';

@Injectable({
    providedIn: 'root'
})
export class ReportsCrmService {

    constructor(private http: HttpClient) {
    }


    getCreatedTickets(fromDate, toDate, frequency: frequencyData) {
        return this.http.get('/api/ticketNumberRange?fromDate=' + fromDate + '&toDate=' + toDate + '&frequency=' + frequency);
    }

    getTicketsByStatus(fromDate, toDate, frequency: frequencyData, status) {
        return this.http.get('/api/ticketNumberRange?fromDate=' + fromDate + '&toDate=' + toDate + '&frequency=' + frequency + '&status=' + status);
    }

    getPieChartData(fromDate, toDate, status) {
        return this.http.get('/api/getTicketPercentageByStatus?fromDate=' + fromDate + '&toDate=' + toDate + '&ticketStatus=' + status);
    }

}
